<a
  href="#"
  (click)="startCopy($event)"
  (mouseleave)="resetTooltip()"
  [matTooltip]="tooltipText"
  matTooltipPosition="right"
  #tooltip="matTooltip">
  <fa-icon [icon]="['fas', 'copy']" size="sm" />
</a>
